import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SalesOrderPeriodApiService } from './services/sales-order-period-api.service';
import { SalesOrderPeriodEffects } from './store/sales-order-period.effects';
import { salesOrderPeriodReducer } from './store/sales-order-period.reducer';

@NgModule({
  providers: [
    provideState('salesOrderPeriod', salesOrderPeriodReducer),
    provideEffects(SalesOrderPeriodEffects),
    SalesOrderPeriodApiService,
  ],
})
export class SalesOrderPeriodModule {}
